<template>
  <div class="sip_ui_border">
    <div class="sip_controls sip_ui_body">
      <!-- <StatusScale ref="statusScale"  @refill="onRefill" /> -->
      <div class="sip_timer_speedometr_w">
        <!-- <Timer :timer="timer" /> -->
        <ControlsSpeedometr :speed="speed" />
      </div>
      <ControlsUpDown @clicked="onUpDown" />
    </div>
  </div>
</template>
<script>
import ControlsUpDown from './ControlsUpDown.vue'
import ControlsSpeedometr from './ControlsSpeedometr.vue'
import StatusScale from './StatusScale.vue'
import Timer from './Timer.vue'

export default {
  name: 'Controls',
  props: ['speed', 'timer'],
  components: {
    ControlsUpDown,
    ControlsSpeedometr,
    StatusScale,
    Timer,
  },
  computed: {
    speedTitle() {
      if(this.speed > 0) {
        return 'вперед'
      } else if(this.speed < 0) {
        return 'назад'
      } else if(this.speed === 0) {
        return 'стоп'
      }
    }
  },
  methods: {
    onUpDown(val) {
      this.$emit('clicked', val)
    },
    progress() {
      console.log('Progress Mob');
      this.$refs.statusScale.progress()
    },
    onRefill() {
      this.$emit('refill', true)
    }
  },
}
</script>

<style lang="stylus">
.sip_controls
  display flex
  align-items flex-end
  justify-content space-around
  @media screen and (max-width: 900px)
    justify-content space-between
.sip_timer_speedometr_w
  height 137px
  display flex
  flex-direction column
  justify-content space-between
  align-items center
  @media screen and (max-width: 900px)
    height 110px
    justify-content flex-end
.sip_ui
  .sip_btn
    position: absolute
    top 10px
    left 10px
</style>